import Param from './param';
import Util from './module/libs/util';
import loaderManager from './module/libs/loader';
import soundManager from './module/libs/sound';
import barbaManager from './module/barba';
import effectManager from './module/effect';
import Header from './module/global/header';
import Menu from './module/global/menu';
import Color from './module/libs/color';
import scrollIcon from './module/libs/scroll';
import Sns from './module/libs/sns';
import smoothScrollManager from './module/scroll/scrollManager';
import MouseManager from './module/mouse/mouseManager';
import topManager from './page/top/manager';
import sceneManager from './page/scene/manager';
import conceptManager from './page/concept/manager';

export default class Manager {
    constructor() {

        this.w = window.innerWidth;
        this.h = window.innerHeight;

        /* fps計測用 */
        //this.fps = new Stats();
        //this.fps.showPanel( 0 ); // 0: fps, 1: ms, 2: mb, 3+: custom
        //document.body.appendChild( this.fps.dom );

        /* fps低下対策 */
        this.fpsRate;

        /* class用 */
        this.util = new Util();
        this.loader = new loaderManager(this);
        this.sound = new soundManager(this);
        this.sns = new Sns(this);
        this.scrollIcon = new scrollIcon(this);
        this.barba = new barbaManager(this);
        this.param = new Param();
        this.effect;
        this.scroll;
        this.mouse = false;

        this.page; /* ページごとに読み込むのもを入れる */
        //設定

        /* ステータス */
        this.status = {
            loaded : false,
            loadedAddClass : false,
            paceDone : false, // ローダーライブラリ pace用
            pageID : "",
            execution : "landing",
            transFlg : false, //画面遷移監視用のフラグ
            touch : {
                nowInc : 0,
                inc    : 0
            },
            deviceOrientation:"",
        }

        //userAgent
        const _ua = navigator.userAgent
        this.isIpad = /iPad/.test(_ua) || (/Macintosh/.test(_ua) && 'ontouchend' in document)

        //this.ease = CustomEase.create("custom", "M0,0,C0.29,0,0.3,0.025,0.366,0.124,0.414,0.196,0.456,0.374,0.482,0.5,0.51,0.628,0.51,0.686,0.582,0.832,0.625,0.92,0.704,1,1,1");

        //this.ease = CustomEase.create("custom", "M0,0,C0.29,0,0.346,0.026,0.43,0.103,0.504,0.171,0.604,0.352,0.618,0.502,0.632,0.566,0.652,0.777,0.726,0.864,0.802,0.954,0.846,0.978,1,1");

        this.ease = CustomEase.create("custom", "M0,0,C0.166,0,0.262,0.196,0.3,0.3,0.398,0.568,0.572,1,1,1");

        this.$rotatAlert;

        const angle = (screen && screen.orientation && screen.orientation.angle) || window.orientation || 0;
        const isLandscape = angle % 180 !== 0;
        if (isLandscape) {
            this.portrait = false;
        } else {
            this.portrait = true;
        }

    }
    init(){ /* 初期化 */

        if(this.status.execution=="landing"){ //初回読み込みのみ実行
            this.status.pageID = document.getElementsByTagName('body')[0].getAttribute("id");
            this.loadCommon();
            this.loader.init();
            this.scrollIcon.init();
            if (this.isIpad) {
                TweenMax.set('#l-pointer', {
                    display: 'none',
                })
            }
            setTimeout(()=>{
                this.sound.init();
                if (this.isIpad) return
                TweenMax.fromTo('#l-pointer',0.8,{
                    scale:0,
                    opacity:0
                },{
                    scale:1,
                    opacity:1
                });
            }, 23e2);
            TweenMax.set(document.getElementById("l-root"),{opacity:1});
        }else{  //非同期遷移の際に実行
            this.loadPage();
            setTimeout(()=>{
                this.scroll.init();
                this.resize();
                this.status.transFlg = false;
            },1e2);
        }

        if (this.isIpad) {
            document.querySelector("html").classList.add('-isTablet')
        }

    }
    loadCommon(){ /* 共通で読み込むもの */

        this.barba.init();

        this.effect = new effectManager(this);
        this.scroll = new smoothScrollManager(this);
        this.mouse = new MouseManager(this);
        this.header = new Header(this);
        this.menu = new Menu(this);
        this.color = new Color(this);

        this.header.init();

        //this.webgl = new webglManager();

        this.$rotatAlert = document.getElementById("c-rotat-alert");

        setTimeout(()=>{
            this.scroll.init();
            this.menu.init();
            if(this.status.execution==="landing") this.render();
        },1e2);
    }
    loadPage(){ /* ページごとに分岐するもの */

        this.snsDisplaySwitch();
        setTimeout(()=>{
            let _$link = document.getElementsByTagName('a');
            for(let i in _$link){
                if(_$link[i].nodeType!=1) continue; // dom要素以外は処理止める
                _$link[i].classList.remove('no-link');
            }
            if(this.mouse){
                this.mouse.init(this);
            }
        },2e3);

        //ページごとに読み込むもの
        this.page = false;
        if (this.status.pageID == "top") {
            this.page = new topManager(this);
            this.page.init();
            if (this.mouse) this.mouse.status.off = false;
        } else if (this.status.pageID == "scene" || this.status.pageID == "scene-living") {
            this.page = new sceneManager(this);
            this.page.init();
        } else if (this.status.pageID == "concept" || this.status.pageID == "concept_detail") {
            this.page = new conceptManager(this);
            this.page.init();
        }

        if(this.status.execution=="landing") { //初回読み込みのみ実行
            this.resize();
        }

        this.mouse.status.off = Useragnt.mobile || this.isIpad ? true : false;

        if(this.status.execution=="landing") { //初回読み込みのみ実行
            this.status.loaded = true;
            setTimeout(()=>{
                document.getElementsByTagName("html")[0].classList.add("is-loaded");
            },2e3);
        }

    }
    render(){

        if(!requestAnimationFrame){
            setTimeout(()=>this.render,1000/60);
        }else{
            requestAnimationFrame(this.render.bind(this));
        }

        this.fpsRate = this.util.updateTimeRatio();

        //this.fps.begin();

        if(!this.status.transFlg) this.scroll.move(this.fpsRate);
        if(!this.mouse.status.off) this.mouse.move();

        if(this.page && !this.status.transFlg) this.page.render();

        //this.fps.end();

    }
    resize(){

        this.param.displayType = ( window.innerWidth>this.param.breakpoint)?"pc":"sp";

        this.w = window.innerWidth;
        this.h = window.innerHeight;

        // if(pageID==="top")toppage.resize();
        this.scroll.resize(this.w,this.h);
        //this.webgl.resize(this.w,this.h,this.param.displayType);
        if(this.page) this.page.resize(this.w,this.h,this.param.displayType);

    }
    orientation(e){

        let angle = (screen && screen.orientation && screen.orientation.angle) || window.orientation || 0;

        let _roule = Useragnt.mobile || this.isIpad ? angle % 180 !== 0 : false;

        if(_roule) {
            if(this.status.deviceOrientation != "landscape") this.resize()
            this.status.deviceOrientation = "landscape";
            this.$rotatAlert.classList.add("is-show");
            document.querySelector("html").classList.remove('-portrait')
            this.portrait = false;
            window.location.reload();
        } else {
            if(this.status.deviceOrientation != "portrait") this.resize()
            this.status.deviceOrientation = "portrait";
            this.$rotatAlert.classList.remove("is-show");
            document.querySelector("html").classList.add('-portrait')
            this.portrait = true;
            window.location.reload();
        }

    }

    wheel(e){

        if(!this.page) return;

        if((this.status.pageID == "scene" || this.status.pageID == "scene-living") && this.page.status.mode == 'full'){
            e.preventDefault();
        }

        //フルスクリーン系のスペコンでスクロールイベントころすとき

        // let _delta = e.deltaY ? -(e.deltaY) : e.wheelDelta ? e.wheelDelta : -(e.detail);


        // switch (this.status.pageID) {
        //     case 'dummy':
        //         e.preventDefault();
        //         if (_delta < 0){
        //             if (_delta > -30&&Useragnt.mac||_delta > -30&&Useragnt.windows&&!Useragnt.firefox||_delta > -1&&Useragnt.windows&&Useragnt.firefox) return;
        //             this.page.update('next');
        //         }else if (_delta > 0){
        //             if (_delta < 30&&Useragnt.mac||_delta < 30&&Useragnt.windows&&!Useragnt.firefox||_delta < 1&&Useragnt.windows&&Useragnt.firefox) return;
        //             this.page.update('prev');
        //         }
        //         break;
        // }


    }
    touchmove(e){

        // e.preventDefault();

    }
    touchStart(e){
        // touchInc.x = e.touches[0].pageX;
        this.status.touch.inc = e.touches[0].pageY;

    }
    touchEnd(e){

        //フルスクリーン系のスペコンでタッチイベントころすとき

        // this.status.touch.nowInc = e.changedTouches[0].pageY;
        // switch (this.status.pageID) {
        //     case 'dummy':
        //         if(this.gnavi.status.mode=="open") return;
        //         if (this.status.touch.inc > this.status.touch.nowInc && this.status.touch.inc - this.status.touch.nowInc > 50) {
        //             this.page.update('next');
        //         } else if (this.status.touch.inc < this.status.touch.nowInc && this.status.touch.nowInc - this.status.touch.inc > 50) {
        //             this.page.update('prev');
        //         }
        //         break;
        // }

    }
    snsDisplaySwitch() {
        if (this.status.pageID == "top") {
            this.sns.init('show')
        } else {
            this.sns.init('hide')
        }
    }

}